import { mapGetters } from "vuex";
import { TimelineLite } from "gsap/TweenMax";

export default {
  props: {
    duration: {
      default: 5000
    }
  },
  data() {
    return {
      timer: null,
      current: 0,
      wrapperWidth: 0,
      process: []
    };
  },
  computed: {
    ...mapGetters(["isMobile"]),
    translateX() {
      return (this.current / 3) * this.wrapperWidth;
    },
    style() {
      return {
        transform: `translateX(${this.translateX}px)`
      };
    }
  },
  watch: {
    isMobile() {
      this.init();
    }
  },
  mounted() {
    // 计算参数监听
    window.onresize = () => {
      if (this.$refs.process) {
        this.wrapperWidth = this.$refs.process.clientWidth;
      }
    };

    // 初始化
    this.init();
  },
  beforeDestroy() {
    !this.isMobile && this.clearAnimation();
  },
  methods: {
    init() {
      this.isMobile ? this.clearAnimation() : this.initTL();
    },

    initTL() {
      this.clearCurrent();
      this.tl = new TimelineLite();
      this.wrapperWidth = this.$refs.process.clientWidth;
      // this.initInterval();
    },

    initInterval() {
      this.timer = setInterval(() => {
        this.current += 1;
        if (this.current > 2) {
          this.current = 0;
        }
        this.setTweenLite(this.translateX);
      }, this.duration);
    },

    // 重置当前选中项
    clearCurrent() {
      this.current = this.isMobile ? -1 : 0;
    },

    // 清空轮播参数
    clearAnimation() {
      this.clearCurrent();
      this.tl && this.setTweenLite(0);
      clearInterval(this.timer);
    },

    mouseEnter(index) {
      if (this.isMobile) return;

      this.current = index;
      clearInterval(this.timer);
      this.setTweenLite(this.translateX);
    },

    mouseLeave() {
      if (this.isMobile) return;

      // this.initInterval();
    }
  }
}